var exports = {
  "PT": "Markup.module__markup___SXZVSF",
  "z3": "Markup.module__bio___SXZVSF",
  "Z_": "Markup.module__mutedSpoilerContext___SXZVSF",
  "nf": "Markup.module__link___SXZVSF",
  "mG": "Markup.module__inline___SXZVSF",
  "tZ": "Markup.module__inlineFormat___SXZVSF",
  "Hy": "Markup.module__codeContainer___SXZVSF",
  "h": "Markup.module__blockquoteContainer___SXZVSF",
  "xE": "Markup.module__alert___SXZVSF",
  "CZ": "Markup.module__tableContainer___SXZVSF",
  "js": "Markup.module__latexCodeBlock___SXZVSF",
  "lB": "Markup.module__codeActions___SXZVSF",
  "vo": "Markup.module__codeActionsVisible___SXZVSF",
  "r": "Markup.module__blockquoteDivider___SXZVSF",
  "rs": "Markup.module__blockquoteContent___SXZVSF",
  "em": "Markup.module__blockquoteEmptyContent___SXZVSF",
  "tp": "Markup.module__table___SXZVSF",
  "qd": "Markup.module__tableHeader___SXZVSF",
  "xR": "Markup.module__tableCell___SXZVSF",
  "Vl": "Markup.module__alignLeft___SXZVSF",
  "Hu": "Markup.module__alignCenter___SXZVSF",
  "Wk": "Markup.module__alignRight___SXZVSF",
  "Qd": "Markup.module__alertIcon___SXZVSF",
  "Ro": "Markup.module__alertTitle___SXZVSF",
  "S9": "Markup.module__alertContent___SXZVSF",
  "FU": "Markup.module__alertNote___SXZVSF",
  "ap": "Markup.module__alertTip___SXZVSF",
  "nL": "Markup.module__alertImportant___SXZVSF",
  "vc": "Markup.module__alertWarning___SXZVSF",
  "SN": "Markup.module__alertCaution___SXZVSF",
  "lE": "Markup.module__mention___SXZVSF",
  "bG": "Markup.module__interactive___SXZVSF",
  "vE": "Markup.module__timestamp___SXZVSF",
  "CU": "Markup.module__spoilerWrapper___SXZVSF",
  "N5": "Markup.module__blockSpoilerWrapper___SXZVSF",
  "p6": "Markup.module__spoiler___SXZVSF",
  "mC": "Markup.module__blockSpoiler___SXZVSF",
  "ur": "Markup.module__spoilerContent___SXZVSF",
  "yI": "Markup.module__latexContent___SXZVSF",
  "Y4": "Markup.module__hljs___SXZVSF",
  "HQ": "Markup.module__ansiCode___SXZVSF",
  "bi": "Markup.module__ansi-code-blink___SXZVSF",
  "So": "Markup.module__error___SXZVSF",
};

module.exports = exports;
